export default __webpack_public_path__ + "static/media/download.ceb54360.svg";